// extracted by mini-css-extract-plugin
export var active = "_84-a";
export var activeIndicator = "_84-9";
export var disabled = "_84-b";
export var fullWidth = "_84-2";
export var lg = "_84-7";
export var md = "_84-6";
export var redoButtonTabGroup = "_84-0";
export var sm = "_84-5";
export var tabButton = "_84-4";
export var tabButtonsContainer = "_84-1";
export var themeDestructive = "_84-d";
export var themeNormal = "_84-c";
export var themeSuccess = "_84-e";
export var xl = "_84-8";
export var xs = "_84-3";